export const shape = {
    borderRadius: {
        default: '4px',
        lg: '8px',
    },
};
//# sourceMappingURL=shape.js.map